import { AnyAppEvent, AppEvent } from "../../appEvent.types";

const eventName = "commercialisation-comment-tag" as const;

export type CommercialisationCommentTagEventData = {
  commentId: string;
  userId: string;
};
export type CommercialisationCommentTagEvent = AppEvent<
  typeof eventName,
  CommercialisationCommentTagEventData
>;

export const isCommercialisationCommentTagEvent = (
  event: AnyAppEvent
): event is CommercialisationCommentTagEvent => event.name === eventName;

export { eventName as commercialisationCommentTag };
